import {isMacOS} from '../../../utils/platform';

export const iSearchDropdownCloseKey = event => {
    const isMac = isMacOS();
    if ((isMac && event.metaKey) || (!isMac && event.ctrlKey)) {
        return event.code === 'ArrowUp' || event.code === 'ArrowDown';
    }
    return false;
};
